import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { AffectedCustomer } from '../types';
import { Translate } from '../../../shared/LanguageService';

type ConfirmDeactivationDialogProps = {
    open: boolean;
    customers: AffectedCustomer[];
    onConfirm: () => void;
    onCancel: () => void;
};

function fallbackText(customer: AffectedCustomer): string {
    return customer.fallbackCustomerAgreementName
        ? Translate('customer-agreements/confirm-deactivation/falls-back-to-chain-agreement', {
              customer: customer.name,
              agreement: customer.fallbackCustomerAgreementName
          })
        : Translate('customer-agreements/confirm-deactivation/falls-back-to-standard', {
              customer: customer.name
          });
}

export function ConfirmDeactivationDialog({
    open,
    customers,
    onConfirm,
    onCancel
}: ConfirmDeactivationDialogProps) {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            maxWidth="sm"
            fullWidth
            aria-labelledby="confirm-customer-agreement-deactivation-title"
        >
            <DialogTitle id="confirm-customer-agreement-deactivation-title">
                {Translate('customer-agreements/confirm-deactivation/title')}
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="body1">
                    {Translate('customer-agreements/confirm-deactivation/intro')}
                </Typography>
                <List dense>
                    {customers.map((customer) => (
                        <ListItem key={`${customer.kind}-${customer.name}`} disableGutters>
                            <ListItemText
                                primary={fallbackText(customer)}
                                secondary={
                                    customer.inheritingFirmCount > 0
                                        ? Translate(
                                              'customer-agreements/confirm-deactivation/chain-firms',
                                              {
                                                  count: customer.inheritingFirmCount
                                              }
                                          )
                                        : null
                                }
                            />
                        </ListItem>
                    ))}
                </List>
                <Typography variant="body2">
                    {Translate('customer-agreements/confirm-deactivation/plan-only-note')}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>
                    {Translate('customer-agreements/confirm-deactivation/button/cancel')}
                </Button>
                <Button variant="contained" color="warning" onClick={onConfirm}>
                    {Translate('customer-agreements/confirm-deactivation/button/confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
